import type { IdeaBankItem, JourneyPhaseDraft } from "../api/pwf";

/** "roughly X–Y real weeks": X = Σ estWeeks (default 2/phase), Y = X + 15% headroom. */
export function pathWeeksRange(phases: Array<{ estWeeks?: number }>): { min: number; max: number } {
  const min = phases.reduce((sum, p) => sum + (p.estWeeks ?? 2), 0);
  const max = min + Math.max(1, Math.ceil(min * 0.15));
  return { min, max };
}

/** A trimmed phase becomes an Ideas entry — never deleted (v3 §−2). */
export function trimmedPhaseToIdea(phase: JourneyPhaseDraft): IdeaBankItem {
  return {
    text: `${phase.title} — ${phase.doSide}`,
    side: "do",
    facet: "plan",
    phaseTitle: phase.title,
    source: "wizard",
  };
}
